import React, { useContext } from 'react';
import MarkdownAnchor from '../MarkdownAnchor';
import { AuthContext } from '../../context/auth-context';
import { PRACTITIONER_STATUS_MESSAGE } from '../../data/constants';

const PractitionerStatusMessage = props => {
  const { variant = 'long', ...rest } = props;
  const { actions: authActions } = useContext(AuthContext);
  const { getShopifyCustomer, getPractitionerStatus, getPractitionerStatusMessage } = authActions;
  const { numberOfOrders } = getShopifyCustomer();
	const { isActiveExpress } = getPractitionerStatus();
  const MESSAGE = getPractitionerStatusMessage();

  if (!MESSAGE) {
    return null;
  }

  if (isActiveExpress && numberOfOrders > 0) {
    return (
      <MarkdownAnchor
        text={PRACTITIONER_STATUS_MESSAGE.INCOMPLETE.LONG}
        {...rest}
      />
    );
  }

  return (
    <MarkdownAnchor
      text={MESSAGE[variant.toUpperCase()] || MESSAGE.LONG}
      {...rest}
    />
  );
};

export default PractitionerStatusMessage;
